export const STATUS_ANALISE = [
  { value: 'EM_ANALISE', label: 'Em análise' },
  { value: 'PENDENTE_DE_ESCLARECIMENTO', label: 'Pendente de esclarecimento' },
  { value: 'ANALISADO', label: 'Analisado' },
] as const;
